import { CompanyContext } from './context/context';
import { Company } from './types';

export type PdfCompanyInfo = Pick<Company, 'name' | 'address' | 'fax' | 'iata' | 'phone' | 'website'>;
export const getPdfCompanyInfo: (companiesContext: CompanyContext) => PdfCompanyInfo = (
    companiesContext: any
) => {
    const currCompany: Company | undefined = companiesContext.data[0];
    return {
        name: currCompany?.name || '',
        phone: currCompany?.phone || '',
        website: currCompany?.website || '',
        address: currCompany?.address || '',
        fax: currCompany?.fax || '',
        iata: currCompany?.iata || '',
        vat: currCompany?.vat || ''
    };
};
